import React from 'react';
import { useQuery } from '@apollo/client';

import Input from 'app/src/elements/inputs';

import { BUYERS } from './queries';

const BuyerPicker = ({ excludeId, ...props }) => {
  const { data } = useQuery(BUYERS, { variables: { scopes: ['active'] } });

  if (!data) { return null; }

  const options = data.buyers.filter(({ id }) => id !== excludeId ).
    map(({ name, id, ...buyer }) => ({
      value: id,
      label: `${name} | ID ${id} | ${buyer.city} | ${buyer.email} | ` +
        `${buyer.phoneNumber.formatted}`
    }));

  return (
    <Input.Picker
      {...props}
      options={options}
    />
  );
};

export default BuyerPicker;
